module.exports = __webpack_public_path__ + "static/media/clemgram_black.7964d654.jpg";